import { IJackpot } from 'js/hooks/useGetJackpots/types';

import { IJackpotTickerData } from './types';

export const getInitialTickerData = (jackpotStartTime: number | null, jackpot: IJackpot): IJackpotTickerData => {
    const startTime = jackpotStartTime || Date.now();
    const { step, amount, hitTime, originAmount, currencyCode } = jackpot;

    return {
        amount,
        amountStartTime: startTime,
        changeTypeStartTime: startTime,
        currencyCode,
        hitTime: null,
        hitTimeStartTime: startTime,
        isHitTimeEnded: !hitTime,
        isLimitReached: false,
        originAmount,
        showHitTime: false,
        step,
        tempHitTime: typeof hitTime === 'number'
            ? new Date(hitTime * 1000).getTime() - startTime
            : null
    };
};
